import { z } from 'zod';

// ../../node_modules/@jwplayer/fe-common/constants/regex.js
var REGEX_PLAYER_LICENSEY_KEY = /^[\d\w+_/=]{48,64}$/;
var REGEX_ACCOUNT_ID = /[a-z0-9]{8}/gim;
var REGEX_ACCOUNT_UUID = /^[\d\w-]{36}$/;
var REGEX_ANALYTICS_TOKEN = /^[\d\w+_]{22}$/;

// ../../node_modules/@jwplayer/fe-common/module/util/index.js
function isValidSalesforceId(str) {
  if (typeof str !== "string" || str.length !== 18) {
    return false;
  }
  const upperCaseToBit = (char) => char.match(/[A-Z]/) ? "1" : "0";
  const binaryToSymbol = (digit) => digit <= 25 ? String.fromCharCode(digit + 65) : String.fromCharCode(digit - 26 + 48);
  const parts = [
    str.slice(0, 5).split("").reverse().map(upperCaseToBit).join(""),
    str.slice(5, 10).split("").reverse().map(upperCaseToBit).join(""),
    str.slice(10, 15).split("").reverse().map(upperCaseToBit).join("")
  ];
  const check = parts.map((str2) => binaryToSymbol(Number.parseInt(str2, 2))).join("");
  return check === str.slice(-3);
}
var zRelationships = (names) => {
  const one = (name) => z.object({
    id: zId,
    type: z.literal(name)
  }).optional();
  const many = (name) => z.array(
    z.object({
      id: zId,
      type: z.literal(name)
    })
  ).optional();
  const obj = Object.entries(names).reduce(
    (acc, [key, value]) => {
      acc[key] = value === null ? one(key) : many(value);
      return acc;
    },
    {}
  );
  return z.object(obj);
};
var zDateTimeString = {
  /**
   * ISO8601 date string with TZ offset used in most APIs
   */
  full: z.string().datetime({ offset: true }),
  /**
   * Simple daily date format YYYY-MM-DD (used in Analytics)
   */
  day: z.string().regex(/\d{4}-\d{2}-\d{2}/gim),
  /**
   * Simple monthly date format YYYY-MM (used in Analytics)
   */
  month: z.string().regex(/\d{4}-\d{2}/gim)
};
var zId = z.string().regex(REGEX_ACCOUNT_ID);
var zAccountUuid = z.string().regex(REGEX_ACCOUNT_UUID);
z.string().regex(REGEX_PLAYER_LICENSEY_KEY);
z.string().regex(REGEX_ANALYTICS_TOKEN);
z.string().refine((str) => isValidSalesforceId(str), {
  message: "Invalid Salesforce ID"
});
var zRecordFromTuple = (keys, zodValueType) => {
  return z.object(
    keys.reduce(
      (acc, k) => {
        acc[k] = zodValueType;
        return acc;
      },
      {}
    )
  );
};
var zPositiveInt = z.number().int().positive();
var zNonNegativeInt = z.number().int().nonnegative();
function zNumericEnum(values) {
  return z.number().superRefine((val, ctx) => {
    if (!values.includes(val)) {
      ctx.addIssue({
        code: z.ZodIssueCode.invalid_enum_value,
        options: [...values],
        received: val
      });
    }
  });
}
var zJson = z.lazy(
  () => z.union([z.string(), z.number(), z.boolean(), z.null(), z.array(zJson), z.record(zJson)])
);
var zApiEntity = (type) => z.object({
  id: zId,
  type: z.literal(type),
  schema: z.string().nullable(),
  created: zDateTimeString.full,
  last_modified: zDateTimeString.full,
  relationships: z.record(z.unknown()).optional()
});

export { REGEX_ACCOUNT_UUID, zAccountUuid, zApiEntity, zDateTimeString, zId, zJson, zNonNegativeInt, zNumericEnum, zPositiveInt, zRecordFromTuple, zRelationships };
//# sourceMappingURL=chunk-H27MX3SA.js.map
//# sourceMappingURL=chunk-H27MX3SA.js.map